module.exports = __webpack_public_path__ + "img/logo3.e614dff6.png";